import React, { createContext, useState, useLayoutEffect, useEffect, useRef } from 'react';

import { useTheme } from '@mui/material/styles';
import {
  InputBase,
} from '@mui/material';

//-----------------------------------------------------------------
export function Select( props ) { // = React.memo(props => {
  //-----------------------------------------------------------------
  
  //#region [Main] state

  const { innerRef, has_focus, inputStyle, inputContentStyle, disabled } = props;

  const theme = useTheme();

  const {
    containerClass = 'fieldBody',
    inputClass = 'fieldInput',
  } = props;

  const [is_open, setOpen] = useState(false);

  const options = props.options;
  const [ options_formatted , setOptionsFormatted ] = useState( { items: {}, order: [] } );
  const [ selected_index    , setSelectedIndex    ] = useState( -1 );

  const [ content , setContent ] = useState( props.value );

  let selectRef = useRef();
  let ref_menu  = useRef();

  // AUTO-MODE
  const is_auto_mode      = localStorage.getItem( 'auto-mode' ) === 'true';
  const auto_mode_latency = localStorage.getItem( 'auto-mode-latency' ) * 1;

  //#endregion

  //#region [ACCESS]


  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    if( is_auto_mode && has_focus ) setTimeout( autoKey, auto_mode_latency );
  }, [is_auto_mode, has_focus])

  // ===

  useEffect( () => {
    setContent( props.value );
  }, [props.value] )

  useEffect( () => {
    let match_index = -1;
    const has_no_content = content === '';
    const initial_value  = content === props.value;

    const is_not_filtering = has_no_content || initial_value;

    //-----------------------------------------------------------------
    function createOptionsFormatted() {
      //-----------------------------------------------------------------
      const result = {
        options: { items: {}, order: [] },
      };

      if( is_not_filtering ) result.display = options;

      let info = { key_index_last: 0 };
      options.forEach(option => {
        if (option.options) { // Has grouped options
          option.options.forEach( group_option => {
            createOption( result, group_option, info );
          });
        } else {
          createOption( result, option, info );
        }
      });

      return result;
    };

    //-----------------------------------------------------------------
    function createOption( source, option, info ) {
      //-----------------------------------------------------------------
      if(is_not_filtering) { // show everything
        source.options.items[option.value] = option;
        source.options.order.push( option );
        return;
      }

      const is_duplicate = source.options.items.hasOwnProperty(option.value);

      if( is_duplicate ) return;

      const is_match_label = option.label.toUpperCase().includes( content.toUpperCase() );
      const is_match_value = option.value.toUpperCase().includes( content.toUpperCase() );
      const is_match_value_exact = option.value.toUpperCase() === content.toUpperCase();

      if( is_match_label || is_match_value ) source.options.items[option.value] = option;

      if( is_match_value_exact ) {
        match_index = info.key_index_last;
        source.options.order.splice( 0, 0, option );
        info.key_index_last++;
      } else if( is_match_value ) {
        source.options.order.splice( info.key_index_last, 0, option );
        info.key_index_last++;
      } else if( is_match_label ) {
        source.options.order.push( option );
      }
    }

    const items = createOptionsFormatted();
    setOptionsFormatted( items );

    const has_content = content !== '';
    const has_values  = items.options.order.length > 0;
    if( is_open && !is_not_filtering && has_content &&  has_values ) {
      setSelectedIndex( 0 );
    }
    if( has_content && !has_values ) {
      setSelectedIndex( -1 );
    }
    if( !has_content ) {
      setSelectedIndex( -1 );
    }

  }, [options, content] );

  //#endregion

  //#region [METHOD]

  //-----------------------------------------------------------------
  function changeInputValue( trigger, value ) {
    //-----------------------------------------------------------------
    let newEvent = new Event('change', {
      bubbles: true,
      cancelable: true,
    });

    newEvent.value    = value;
    newEvent.trigger  = trigger;
    newEvent.isSubmit = true;

    onChange( newEvent );
  }

  //-----------------------------------------------------------------
  function autoKey() {
    //-----------------------------------------------------------------
    try {
      const key_enter = { key: 'Enter', ctrlKey: true };
      const event = new KeyboardEvent( 'keydown', key_enter );
      onKeyDown( event );
    } catch (error) {
      console.warn( error );
    }
  }

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onFocus(event) {
    //-----------------------------------------------------------------
    if (typeof props.onFocus === 'function') {
      props.onFocus(event);
    }
  }

  //-----------------------------------------------------------------
  function onBlur(event) {
    //-----------------------------------------------------------------
    setOpen(false);
    
    if (typeof props.onBlur === 'function') {
      props.onBlur(event);
    }
  }

  //-----------------------------------------------------------------
  function onChange(event) {
    //-----------------------------------------------------------------
    if (typeof props.onChange === 'function') {
      props.onChange(event);
    }
  }

  //-----------------------------------------------------------------
  function onInputChange(event) {
    //-----------------------------------------------------------------
    let value = event.target.value;
    setContent( value );
    if( !is_open) setOpen(true);
  }

  //-----------------------------------------------------------------
  function onKeyDown(event) {
    //-----------------------------------------------------------------
    if (typeof props.onKeyDown === 'function') {
      props.onKeyDown(event);
    }

    switch (event.key) {
      case 'ArrowUp'   : _handleArrowUp  ()        ; break;
      case 'ArrowDown' : _handleArrowDown()        ; break;
      case 'Enter'     : _handleEnter    ( event ) ; break;
      case 'Tab'       : _handleTab      ( event ) ; break;
      case 'Escape'    : _handleEsc      ()        ; break;
    }
    return;
    //   case 'Home':
    //     if (!isOpen) return;
    //     setSelectedItem(0);
    //     break;
    //   case 'End':
    //     if (!isOpen) return;
    //     setSelectedItem(data.length - 1);
    //     break;
    // }
  }

  // === KEY EVENTS ===

  //-----------------------------------------------------------------
  function _handleArrowUp() {
    //-----------------------------------------------------------------
    if( !is_open ) setOpen( true );
    
    if( selected_index < 0 ) {
      const last = options_formatted.options.order.length - 1;

      setSelectedIndex( last );
    } else {
      const index = selected_index;
      const is_first = index <= 0;
      const next = is_first ? options_formatted.options.order.length - 1 : index - 1;

      setSelectedIndex( next );
    }
  }

  //-----------------------------------------------------------------
  function _handleArrowDown() {
    //-----------------------------------------------------------------
    if( !is_open ) setOpen( true );

    if( selected_index < 0 ) {

      setSelectedIndex( 0 );
    } else {
      const index = selected_index;
      const is_last = index >= options_formatted.options.order.length - 1;
      const next = is_last ? 0 : index + 1;

      setSelectedIndex( next );
    }
  }

  //-----------------------------------------------------------------
  function _handleEnter( event ) {
    //-----------------------------------------------------------------
    if( event.ctrlKey ) {
      changeInputValue( 'FORCED', content );
      setContent( content );
      setOpen( false );
      setSelectedIndex( -1 );
      return;
    }

    const is_empty = content === '';

    if( selected_index < 0 || (is_empty && !is_open) ) {
      if( is_empty ) {
        changeInputValue( 'ENTER', '' );
        setContent( '' );
        setOpen( false );
      } else if( options_formatted.options ) {
        const content_comp = content.toUpperCase();
        const matches = options_formatted.options.order.filter( x => x.label.toUpperCase() === content_comp );
        if( matches.length > 0 ) {
          changeInputValue( 'ENTER', matches[0].value );
          setOpen( false );
        } else {
          changeInputValue('ENTER', content );
          setOpen(false);
        }
      }
      return;
    }

    setSelectedIndex(-1);
    changeInputValue('ENTER', options_formatted.options.order[selected_index]?.value);
    setContent(options_formatted.options.order[selected_index]?.label);
    setOpen(false);
  }

  //-----------------------------------------------------------------
  function _handleTab( event ) {
    //-----------------------------------------------------------------
    event.preventDefault();
    event.stopPropagation();

    if ( event.shiftKey ) return;

    const is_empty = content === '';

    if( selected_index < 0 || (is_empty && !is_open) ) {
      if( is_empty ) {
        changeInputValue('TAB', '');
        setContent( '' );
        setOpen( false );
      } else {
        const content_comp = content.toUpperCase();
        const matches = options_formatted.options.order.filter( x => x.label.toUpperCase() === content_comp );
        if( matches.length > 0 ) {
          changeInputValue('TAB', matches[0].value);
          setOpen( false );
        } else {
          changeInputValue('TAB', content );
          setOpen(false);
        }
      }
      return;
    }

    setSelectedIndex(-1);
    changeInputValue('TAB', options_formatted.options.order[selected_index].value);
    setContent(options_formatted.options.order[selected_index].label);
    setOpen(false);
  }

  //-----------------------------------------------------------------
  function _handleEsc( ) {
    //-----------------------------------------------------------------
    setOpen( false );
  }

  //-----------------------------------------------------------------
  function selectMenuItem(value) {
    //-----------------------------------------------------------------
    let option = options_formatted.options.items[value];
      
    setSelectedIndex( -1 );
    changeInputValue( 'CLICK', value);
    setContent( option.label);
    setOpen( false );
  } 
  
  //-----------------------------------------------------------------
  function handleMouseEnter(index) {
    //-----------------------------------------------------------------
    setSelectedIndex( index );
  }

  //#endregion

  //#region [RENDER]

  const INPUT = {
    inputRef    : innerRef      ,
    sx          : inputStyle    ,
    value       : content       ,
    onChange    : onInputChange ,
    onKeyDown   : onKeyDown     ,
    autoComplete : "off"        ,
    disabled    : disabled      ,
    inputProps: { sx: inputContentStyle || inputStyle },
  }

  const MENU = {
    isOpen: is_open                 ,
    content                         ,
    selected_index                  ,
    ref_menu                        ,
    width        : inputStyle.width ,
    options      : options_formatted,
    disabled     : disabled         ,
    onClick      : selectMenuItem   ,
    onMouseEnter : handleMouseEnter ,    
  }

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <>
        <div className={containerClass} ref={selectRef} onFocus={onFocus} onBlur={onBlur} onChange={onChange} disabled={disabled}>
          <InputBase { ...INPUT  } />
        </div>
        <SelectMenu { ...MENU } ref_menu={ref_menu}/>
      </>
    );
  }

  //#endregion

  return display();
}; //);


//-----------------------------------------------------------------
function SelectMenu( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { isOpen, options, selected_index, width, onClick, onMouseEnter } = props;

  const theme = useTheme();

  const class_group  = 'menuGroup' ;
  const class_option = 'menuItem'  ;

  const [ is_open, setIsOpen ] = useState( isOpen );

  let ref_menu   = useRef();
  let ref_option = useRef();

  //#endregion

  //#region [STYLES]

  const _styles = {
    menu: {
      display         : 'block'      ,
      position        : 'relative'   ,
      width           : width        ,
      maxHeight       : '40rem'      ,
      borderRadius    : '0 0 5px 5px' ,
      borderStyle     : 'solid'      ,
      borderTop       : '',
      borderColor     : theme.palette.primary[theme.palette.mode],
      backgroundColor : theme.palette.background.primary[theme.palette.mode],
      paddingTop      : '1rem'       ,
      paddingBottom   : '1rem'       ,
      overflow        : 'auto'       ,
      zIndex          : '10'         ,
    },
  }

  //#endregion
  
  //#region [EFFECT] 
  
  // ===

  useLayoutEffect(() => {
    if (ref_option.current) {
      const menuRect    = ref_menu.current.getBoundingClientRect();
      const focusedRect = ref_option.current.getBoundingClientRect();

      const overScroll = ref_option.current.offsetHeight / 3;

      if (focusedRect.bottom + overScroll > menuRect.bottom) {
        ref_menu.current.scrollTop = Math.min(
          ref_option.current.offsetTop + ref_option.current.clientHeight - ref_menu.current.offsetHeight + overScroll,
          ref_menu.current.scrollHeight
        );
      } else if (focusedRect.top - overScroll < menuRect.top) {
        ref_menu.current.scrollTop = Math.max(ref_option.current.offsetTop - overScroll, 0);
      }
    }
  }, [selected_index] );

  //#endregion

  //#region [EVENTS]

  //#endregion
  
  //#region [RENDER]

  //-----------------------------------------------------------------
  function displayMenuItems() {
    //-----------------------------------------------------------------
    var offset = 0;
    if( options.display ) {
      return options.display.map( (item) => {
        const displayMenu = item.options ? displayMenuGroup : displayMenuItem;
        const disp_item = displayMenu(item, offset);
        offset += item.options ? item.options.length : 1;
        return disp_item;
      });
    }

    return options.options.order.map( (item, index) => {
      const  display_item = item.options ? displayMenuGroup : displayMenuItem;
      return display_item( item, index );
    });
  }

  //-----------------------------------------------------------------
  function displayMenuGroup( group, offset ) {
    //-----------------------------------------------------------------
    const group_options = group.options.map((item, index) => displayMenuItem(item, offset + index));

    return (
      <div key={'group-' + group.label} className={class_group + 'Header'}>
        <div style={{color: theme.palette.primary.main}}>{group.label}</div>
        <div className={class_group}>{group_options}</div>
      </div>
    );
  };

  //-----------------------------------------------------------------
  function displayMenuItem( option, index ) {
    //-----------------------------------------------------------------
    const is_focused = index === selected_index;
    const selected   = is_focused ? ' selected' : '';

    const ITEM = {
      id       : option.value,
      key      : index,
      onMouseDown  : () => { onClick(option.value, option.label) },
      onMouseEnter : () => { onMouseEnter(index) },
      style    : {
        paddingLeft     : '1rem' ,
        color           : is_focused ? theme.palette.primary.contrastText : '',
        backgroundColor : is_focused ? theme.palette.primary.main : '',
      },
      ref      : current => (is_focused ? (ref_option.current = current) : undefined),
    }

    return (
      <div { ...ITEM } >
        {option.label}
      </div>
    );
  }

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    if( !isOpen ) return null;

    return (
      <div style={_styles.menu} ref={ref_menu} >
        {displayMenuItems()}
      </div>
    )
  }

  //#endregion

  return display();
}
